import React from 'react';
import styled from 'styled-components'
import euStarsImg from '../../static/img/euStars.svg'


const PlateDiv = styled.div`
background-color: white;
border-radius: 10px;
width: 17rem;
font-family: 'Roboto', sans-serif;
font-style: normal;
font-weight: normal;
font-size: 2rem;
line-height: 1.4rem;
text-align: center;
padding: .7rem 1rem;
margin: 1rem auto;
display: block;
position: relative;
box-sizing: border-box;
overflow: hidden;
//box-shadow: rgba(0, 0, 0, 0.85) !important;
border: solid 2px;
box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.25);
`
const PlateBadge = styled.div`
position: absolute;
background: #2E56BA;
//border-radius: 10px 0px 0px 10px;
left: 0;
top: 0;
width: 3rem;
height: 100%;
`
const EuStars = styled.img`
position: absolute;
top: 50%;
left: 50%;
transform: translate(-50%, -50%);
width: 1.5rem;
height: 1.5rem;
`
const PlateInput = styled.input`
font-family: 'Roboto', sans-serif;
font-style: normal;
font-weight: normal;
font-size: 1.6rem;
line-height: 1.4rem;
text-align: center;
border: none;
right: 0;
top: 50%;
width: 80%;
margin-left: 2rem;
background-color: transparent;
text-transform: uppercase;
&:focus {
outline: none;
}
`

export function LicencePlate(props) {
    return (
        <PlateDiv>
            <PlateBadge>
                <EuStars src={euStarsImg} alt="eu plate"/>
            </PlateBadge>
            <PlateInput
                placeholder={'ABC123'}
                onChange={props.onChange}
                value={props.value}
                disabled={props.disabled}
            />
        </PlateDiv>
    )
}